import React from "react";
import Footer from "./Footer";
import Header from "./Header";

const Settings = () => {
  return (
    <div>
      <Header>
        <div class="content">
          <div class="row justify-content-between align-items-center">
            <div class="col-12 col-md-8">
              <h2 class="mb-1">Settings</h2>
              <p class="text-muted mb-0">
                Manage your account, shipment preferences, and integrations in
                one place.
              </p>
            </div>
          </div>

          <div class="settings-grid mt-3">
            <section class="settings-section settings-section--elevated">
              <div class="settings-section-header">
                <div class="settings-section-badge">
                  <i class="bi bi-person-gear"></i>
                </div>
                <div>
                  <h5>Profile Management</h5>
                  <p>
                    Take control of your identity, security, and team access
                  </p>
                </div>
              </div>
              <div class="settings-cards settings-cards--3">
                <a href="/profile_update" class="settings-card">
                  <div class="settings-card-top">
                    <div class="settings-card-icon">
                      <i class="bi bi-building"></i>
                    </div>
                    <span class="settings-card-tag">Profile</span>
                  </div>
                  <div class="settings-card-content">
                    <h6>Profile</h6>
                    <p>Manage your profile information</p>
                  </div>
                  <div class="settings-card-footer">
                    <span>View Profile</span>
                    <i class="bi bi-arrow-right settings-card-arrow"></i>
                  </div>
                </a>
                <a href="/change_password" class="settings-card">
                  <div class="settings-card-top">
                    <div class="settings-card-icon">
                      <i class="bi bi-shield-lock"></i>
                    </div>
                    <span class="settings-card-tag">Security</span>
                  </div>
                  <div class="settings-card-content">
                    <h6>Change Password</h6>
                    <p>Stay protected with strong credentials and updates</p>
                  </div>
                  <div class="settings-card-footer">
                    <span>Update Password</span>
                    <i class="bi bi-arrow-right settings-card-arrow"></i>
                  </div>
                </a>
                <a href="/kyc" class="settings-card">
                  <div class="settings-card-top">
                    <div class="settings-card-icon">
                      <i class="bi bi-person-vcard"></i>
                    </div>
                    <span class="settings-card-tag">Verification</span>
                  </div>
                  <div class="settings-card-content">
                    <h6>KYC Details</h6>
                    <p>Keep your compliance documents safe and up to date</p>
                  </div>
                  <div class="settings-card-footer">
                    <span>Manage KYC</span>
                    <i class="bi bi-arrow-right settings-card-arrow"></i>
                  </div>
                </a>
                <a href="/bank_details" class="settings-card">
                  <div class="settings-card-top">
                    <div class="settings-card-icon">
                      <i class="bi bi-bank2"></i>
                    </div>
                    <span class="settings-card-tag">Payouts</span>
                  </div>
                  <div class="settings-card-content">
                    <h6>Bank Details</h6>
                    <p>Manage your bank account for secure settlements</p>
                  </div>
                  <div class="settings-card-footer">
                    <span>View Bank Details</span>
                    <i class="bi bi-arrow-right settings-card-arrow"></i>
                  </div>
                </a>
                <a href="/team" class="settings-card">
                  <div class="settings-card-top">
                    <div class="settings-card-icon">
                      <i class="bi bi-people"></i>
                    </div>
                    <span class="settings-card-tag">Team</span>
                  </div>
                  <div class="settings-card-content">
                    <h6>Team Management</h6>
                    <p>
                      Add teammates, assign roles and manage access with ease
                    </p>
                  </div>
                  <div class="settings-card-footer">
                    <span>Manage Team</span>
                    <i class="bi bi-arrow-right settings-card-arrow"></i>
                  </div>
                </a>
              </div>
            </section>

            <section class="settings-section settings-section--elevated">
              <div class="settings-section-header">
                <div class="settings-section-badge">
                  <i class="bi bi-box-seam"></i>
                </div>
                <div>
                  <h5>Shipment Settings</h5>
                  <p>Streamline fulfillment with intelligent automation</p>
                </div>
              </div>
              <div class="settings-cards settings-cards--3">
                <a href="/warehouse" class="settings-card">
                  <div class="settings-card-top">
                    <div class="settings-card-icon">
                      <i class="bi bi-geo-alt"></i>
                    </div>
                    <span class="settings-card-tag">Warehouse</span>
                  </div>
                  <div class="settings-card-content">
                    <h6>Warehouse</h6>
                    <p>Manage your warehouse locations in one place</p>
                  </div>
                  <div class="settings-card-footer">
                    <span>Manage Warehouse</span>
                    <i class="bi bi-arrow-right settings-card-arrow"></i>
                  </div>
                </a>

                <a href="/shipping_rules" class="settings-card">
                  <div class="settings-card-top">
                    <div class="settings-card-icon">
                      <i class="bi bi-arrow-down-up"></i>
                    </div>
                    <span class="settings-card-tag">Rules</span>
                  </div>
                  <div class="settings-card-content">
                    <h6>Shipping Rules</h6>
                    <p>Define and manage shipping rules for your orders</p>
                  </div>
                  <div class="settings-card-footer">
                    <span>Manage Rules</span>
                    <i class="bi bi-arrow-right settings-card-arrow"></i>
                  </div>
                </a>
                <a href="/master_label_settings" class="settings-card">
                  <div class="settings-card-top">
                    <div class="settings-card-icon">
                      <i class="bi bi-stickies"></i>
                    </div>
                    <span class="settings-card-tag">Labels</span>
                  </div>
                  <div class="settings-card-content">
                    <h6>Label Configuration</h6>
                    <p>Build and preview shipping labels in real-time</p>
                  </div>
                  <div class="settings-card-footer">
                    <span>Configure Labels</span>
                    <i class="bi bi-arrow-right settings-card-arrow"></i>
                  </div>
                </a>
                <a href="/channel_list" class="settings-card">
                  <div class="settings-card-top">
                    <div class="settings-card-icon">
                      <i class="bi bi-diagram-3"></i>
                    </div>
                    <span class="settings-card-tag">Channels</span>
                  </div>
                  <div class="settings-card-content">
                    <h6>Channel Integration</h6>
                    <p>Manage all your sales channels in one place</p>
                  </div>
                  <div class="settings-card-footer">
                    <span>Manage Channels</span>
                    <i class="bi bi-arrow-right settings-card-arrow"></i>
                  </div>
                </a>
              </div>
            </section>
          </div>
        </div>
      </Header>
      <Footer />
    </div>
  );
};

export default Settings;
